import { Telephone } from '../../../Models/telephone';
import { ShipStatusEnum } from '../../../enums/ship-status-enum';
import { ShipHistory } from './ship-history';

export class DeliveryOperativeDetailDto {
  clientId: number;
  clientName: string;
  clientEmail: string;
  clientTelephones: Telephone[];

  itemId: number;
  itemCode: number;
  itemNombre: string;
  itemDescription: string;

  status: ShipStatusEnum;

  deliveryDate: Date;
  fromHour: string;
  toHour: string;
  comment: string;
  history: ShipHistory[];

}
